export default __webpack_public_path__ + "static/media/cha.c51ba9b2.svg";